<div class="energy-reads-card">
    <div class="er-header">
        <div class="view-toggle">
            <button type="button" [class.active]="viewMode === 'graph'" (click)="setViewMode('graph')">
                <i class="bi bi-bar-chart-line"></i> {{ "GRAPH" | translate }}
            </button>
            <button type="button" [class.active]="viewMode === 'table'" (click)="setViewMode('table')">
                <i class="bi bi-table"></i> {{ "TABLE" | translate }}
            </button>
        </div>
        <div class="range-controls">
        <div class="range-tabs">
            <button type="button" *ngFor="let r of ranges" [class.active]="activeRange === r"
                (click)="selectRange(r)">{{ r }}</button>
        </div>
            @if (viewMode === 'graph') {
            <button type="button" class="reset-zoom-btn" (click)="resetZoom()" [title]="'RESET_ZOOM' | translate">
                <i class="bi bi-zoom-out"></i>
            </button>
            }
        </div>
    </div>

    @if (viewMode === 'graph') {
    <div class="chart-frame">
        @if (readings.length > 0) {
        <canvas baseChart [data]="chartData" [options]="chartOptions" [plugins]="chartPlugins" type="line"></canvas>
        } @else {
        <div class="chart-empty-state">
            <i class="bi bi-bar-chart-line"></i>
            <span>{{ "NO_READS_FOR_RANGE" | translate }}</span>
        </div>
        }
    </div>

    <div class="chart-legend">
        <label class="legend-item" *ngFor="let s of seriesConfig; let i = index">
            @if (readings.length > 0) {
            <input type="checkbox" [checked]="seriesVisible[i]" (change)="toggleSeries(i)" />
            }
            <span class="dot" [style.background-color]="s.color"></span>
            {{ s.labelKey | translate }}
        </label>
    </div>
    }

    @if (viewMode === 'table') {
    <div #tableContainer class="table-container">
        <table>
            <thead>
                <tr>
                    <td class="custom-width">{{ "TIME" | translate | uppercase }} {{ "INTERVAL" | translate }}</td>
                    <td colspan="2">{{ "INSTANTANEOUS_PREFIX" | translate | uppercase }} {{ "ENERGYREGISTERS_ACTIVEPOWER" | translate | uppercase }}</td>
                    <td colspan="2">{{ "MAXIMUM" | translate | uppercase }} {{ "ENERGYREGISTERS_ACTIVEPOWER" | translate | uppercase }}</td>
                    <td colspan="2">{{ "INSTANTANEOUS_PREFIX" | translate | uppercase }} {{ "ENERGYREGISTERS_REACTIVEPOWER" | translate | uppercase }}</td>
                    <td colspan="2">{{ "MAXIMUM" | translate | uppercase }} {{ "ENERGYREGISTERS_REACTIVEPOWER" | translate | uppercase }}</td>
                    <td colspan="2">{{ "INSTANTANEOUS_PREFIX" | translate | uppercase }} {{ "ENERGYREGISTERS_APPARENTPOWER" | translate | uppercase }}</td>
                    <td colspan="2">{{ "MAXIMUM" | translate | uppercase }} {{ "ENERGYREGISTERS_APPARENTPOWER" | translate | uppercase }}</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of tableRows">
                    <td class="table-name-number">
                        <span>{{ row.meterTime | date: 'dd MMM yyyy, h:mm a' }}</span>
                    </td>

                    <!-- Instantaneous Active Power -->
                    <td class="import-cell">
                        <div class="cell">
                            <img alt="Import" src="assets/load-profile/im.svg" />
                            <span [attr.title]="row.instantaneousActivePowerImport + ' W'">
                                {{ row.instantaneousActivePowerImport == null ? 'N/A' : (row.instantaneousActivePowerImport | unitConverter: 'W') }}
                            </span>
                        </div>
                    </td>
                    <td class="export-cell">
                        <div class="cell">
                            <img alt="Export" src="assets/load-profile/ex.svg" />
                            <span [attr.title]="row.instantaneousActivePowerExport + ' W'">
                                {{ row.instantaneousActivePowerExport == null ? 'N/A' : (row.instantaneousActivePowerExport | unitConverter: 'W') }}
                            </span>
                        </div>
                    </td>

                    <!-- Max Demand Active Power -->
                    <td class="import-cell">
                        <div class="cell">
                            <img alt="Import" src="assets/load-profile/im.svg" />
                            <span [attr.title]="row.maxDemandActivePowerImport + ' W'">
                                {{ row.maxDemandActivePowerImport == null ? 'N/A' : (row.maxDemandActivePowerImport | unitConverter: 'W') }}
                            </span>
                        </div>
                    </td>
                    <td class="export-cell">
                        <div class="cell">
                            <img alt="Export" src="assets/load-profile/ex.svg" />
                            <span [attr.title]="row.maxDemandActivePowerExport + ' W'">
                                {{ row.maxDemandActivePowerExport == null ? 'N/A' : (row.maxDemandActivePowerExport | unitConverter: 'W') }}
                            </span>
                        </div>
                    </td>

                    <!-- Instantaneous Reactive Power -->
                    <td class="import-cell">
                        <div class="cell">
                            <img alt="Import" src="assets/load-profile/im.svg" />
                            <span [attr.title]="row.instantaneousReactivePowerImport + ' VAR'">
                                {{ row.instantaneousReactivePowerImport == null ? 'N/A' : (row.instantaneousReactivePowerImport | unitConverter: 'VAR') }}
                            </span>
                        </div>
                    </td>
                    <td class="export-cell">
                        <div class="cell">
                            <img alt="Export" src="assets/load-profile/ex.svg" />
                            <span [attr.title]="row.instantaneousReactivePowerExport + ' VAR'">
                                {{ row.instantaneousReactivePowerExport == null ? 'N/A' : (row.instantaneousReactivePowerExport | unitConverter: 'VAR') }}
                            </span>
                        </div>
                    </td>

                    <!-- Max Demand Reactive Power -->
                    <td class="import-cell">
                        <div class="cell">
                            <img alt="Import" src="assets/load-profile/im.svg" />
                            <span [attr.title]="row.maxDemandReactivePowerImport + ' VAR'">
                                {{ row.maxDemandReactivePowerImport == null ? 'N/A' : (row.maxDemandReactivePowerImport | unitConverter: 'VAR') }}
                            </span>
                        </div>
                    </td>
                    <td class="export-cell">
                        <div class="cell">
                            <img alt="Export" src="assets/load-profile/ex.svg" />
                            <span [attr.title]="row.maxDemandReactivePowerExport + ' VAR'">
                                {{ row.maxDemandReactivePowerExport == null ? 'N/A' : (row.maxDemandReactivePowerExport | unitConverter: 'VAR') }}
                            </span>
                        </div>
                    </td>

                    <!-- Instantaneous Apparent Power -->
                    <td class="import-cell">
                        <div class="cell">
                            <img alt="Import" src="assets/load-profile/im.svg" />
                            <span [attr.title]="row.instantaneousApparentPowerImport + ' VA'">
                                {{ row.instantaneousApparentPowerImport == null ? 'N/A' : (row.instantaneousApparentPowerImport | unitConverter: 'VA') }}
                            </span>
                        </div>
                    </td>
                    <td class="export-cell">
                        <div class="cell">
                            <img alt="Export" src="assets/load-profile/ex.svg" />
                            <span [attr.title]="row.instantaneousApparentPowerExport + ' VA'">
                                {{ row.instantaneousApparentPowerExport == null ? 'N/A' : (row.instantaneousApparentPowerExport | unitConverter: 'VA') }}
                            </span>
                        </div>
                    </td>

                    <!-- Max Demand Apparent Power -->
                    <td class="import-cell">
                        <div class="cell">
                            <img alt="Import" src="assets/load-profile/im.svg" />
                            <span [attr.title]="row.maxDemandApparentPowerImport + ' VA'">
                                {{ row.maxDemandApparentPowerImport == null ? 'N/A' : (row.maxDemandApparentPowerImport | unitConverter: 'VA') }}
                            </span>
                        </div>
                    </td>
                    <td class="export-cell">
                        <div class="cell">
                            <img alt="Export" src="assets/load-profile/ex.svg" />
                            <span [attr.title]="row.maxDemandApparentPowerExport + ' VA'">
                                {{ row.maxDemandApparentPowerExport == null ? 'N/A' : (row.maxDemandApparentPowerExport | unitConverter: 'VA') }}
                            </span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="tableLastPageSize" [numberOfDevices]="tableRowCount"
            [pageSize]="tablePageSize" [currentPage]="tableCurrentPage"
            (pageChange)="loadTableRows($event)"></app-pagination>
    </div>
    }
</div>
